// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"OurResultsData__materialize-textarea___1TrfX","modal-2463794813":"OurResultsData__modal-2463794813___nmTx2","container":"OurResultsData__container___1eR3E","textContainer":"OurResultsData__textContainer___31Jem","header":"OurResultsData__header___3wSEY","question":"OurResultsData__question___16JEv","desc":"OurResultsData__desc___2zoj-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OurResultsData/OurResultsData.scss
// module id = 1508
// module chunks = 0